import { createId } from "../shared/utils";

export const WINDOW_PREFIX = "ForumPresenterTab-";

export const createWindowId = () => `${WINDOW_PREFIX}${createId()}`;

export const getWindowId = () => {
  const windowName = ensureWindowId();

  return windowName.slice(WINDOW_PREFIX.length);
};

export const ensureWindowId = () => {
  if (!window.name.startsWith(WINDOW_PREFIX)) {
    window.name = createWindowId();
  }

  return window.name;
};
